export default {"src":"/_next/static/media/magic-stick.d1d1807c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};